import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPremiere = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.819 4.437a2.17 2.17 0 0 0-2.752-1.317l-.005.002L3.439 7.59h-.002a2.17 2.17 0 0 0-1.317 2.752l.001.005.705 1.996a.75.75 0 0 0 .957.458l.332-.118h.002a1.716 1.716 0 1 1 1.149 3.237l-.332.117a.75.75 0 0 0-.458.957l.705 1.996a2.164 2.164 0 0 0 2.752 1.32l.006-.001L20.56 15.84h.002a2.17 2.17 0 0 0 1.318-2.752l-.002-.005-.704-1.995a.75.75 0 0 0-.957-.458l-.333.117h-.002a1.716 1.716 0 1 1-1.148-3.237l.332-.117a.75.75 0 0 0 .457-.957L18.82 4.44zm-2.542 5.768a3.217 3.217 0 0 0 3.725 2.066l.46 1.306.002.002a.67.67 0 0 1-.405.848L7.444 18.893H7.44a.663.663 0 0 1-.846-.402l-.463-1.312a3.217 3.217 0 0 0-2.133-6.02L3.537 9.85a.67.67 0 0 1 .404-.847L16.56 4.537c.35-.12.725.063.847.404l.462 1.31a3.216 3.216 0 0 0-1.59 3.954m-6.393 1.592.475-1.887c.198-.803 1.142-1.107 1.779-.639l.005.004 1.558 1.167c.365.271.537.744.422 1.191l-.475 1.887c-.198.803-1.142 1.107-1.779.639l-.005-.004-1.558-1.166a1.14 1.14 0 0 1-.422-1.192m1.513.134.284-1.128.929.696-.284 1.128zM7.952 9.04a.75.75 0 0 1-.458.957l-1.853.652a.75.75 0 1 1-.498-1.415l1.853-.652a.75.75 0 0 1 .956.458m8.481-2.208a.75.75 0 0 0-.503-1.413l-1.852.659a.75.75 0 1 0 .502 1.413zm-4.038.636a.75.75 0 0 1-.459.957l-1.852.652a.75.75 0 0 1-.499-1.415l1.853-.652a.75.75 0 0 1 .957.458m-2.282 9.984a.75.75 0 1 0-.504-1.413l-1.847.659a.75.75 0 0 0 .505 1.413zm9.398-4.113a.75.75 0 0 1-.458.957l-1.853.652a.75.75 0 1 1-.498-1.415l1.853-.652a.75.75 0 0 1 .956.458m-4.956 2.54a.75.75 0 1 0-.504-1.412l-1.846.659a.75.75 0 1 0 .504 1.413z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPremiere;
